import React, { useMemo } from 'react';
import PieChart from '../../../components/charts/PieChart';

export default function SecFilingCategoryDonut({
  critical,
  nonCritical,
  total,
  companyKey,
  chartIndex = 0,
  animate = false,
  periodSwitchVersion = 0,
}) {
  const sum = critical + nonCritical;
  const isEmpty = sum === 0;
  const centerTotal = isEmpty ? 0 : (typeof total === 'number' ? total : sum);
  const legendCritical = isEmpty ? 0 : critical;
  const legendNonCritical = isEmpty ? 0 : nonCritical;

  const pieData = useMemo(() => {
    if (isEmpty) return [];
    if (critical === 0) {
      return [{ label: 'non-critical', value: nonCritical, color: 'var(--sec-priority-medium)' }];
    }
    if (nonCritical === 0) {
      return [{ label: 'critical', value: critical, color: 'var(--sec-priority-critical)' }];
    }
    return [
      { label: 'critical', value: critical, color: 'var(--sec-priority-critical)' },
      { label: 'non-critical', value: nonCritical, color: 'var(--sec-priority-medium)' },
    ];
  }, [critical, nonCritical, isEmpty]);

  const pieTitle = isEmpty
    ? '0 filings'
    : `${critical} critical · ${nonCritical} non-critical`;

  return (
    <div
      className={[
        'sec-filing-insights-donut-wrap',
        isEmpty ? 'sec-filing-insights-donut-wrap--empty' : '',
      ].filter(Boolean).join(' ')}
    >
      <div
        className={[
          'sec-filing-insights-donut',
          'sec-filing-insights-donut--pie',
          animate && !isEmpty ? 'sec-filing-insights-donut--animate' : '',
        ].filter(Boolean).join(' ')}
        style={{ '--pie-chart-stagger': `${chartIndex * 40}ms` }}
        title={pieTitle}
      >
        <PieChart
          key={`${companyKey || 'donut'}-ps${periodSwitchVersion}`}
          data={pieData}
          centerValue={centerTotal}
          sublabel="filings"
          animate={animate && !isEmpty}
          animationEpoch={periodSwitchVersion}
          responsive
          glowVariant="neutral"
          className="sec-filing-insights-donut__pie-chart"
        />
      </div>
      <div className="sec-filing-insights-donut-legend">
        <div className="sec-filing-insights-donut-legend__item">
          <span
            className={[
              'sec-filing-insights-donut-legend__dot',
              isEmpty
                ? 'sec-filing-insights-donut-legend__dot--empty'
                : 'sec-filing-insights-donut-legend__dot--critical',
            ].join(' ')}
          />
          <span className="sec-filing-insights-donut-legend__label">Critical</span>
          <span className="sec-filing-insights-donut-legend__count">{legendCritical}</span>
        </div>
        <div className="sec-filing-insights-donut-legend__item">
          <span
            className={[
              'sec-filing-insights-donut-legend__dot',
              isEmpty
                ? 'sec-filing-insights-donut-legend__dot--empty'
                : 'sec-filing-insights-donut-legend__dot--non-critical',
            ].join(' ')}
          />
          <span className="sec-filing-insights-donut-legend__label">Non-critical</span>
          <span className="sec-filing-insights-donut-legend__count">{legendNonCritical}</span>
        </div>
      </div>
    </div>
  );
}
